var document = require('./_global').document;
module.exports = document && document.documentElement;



/*****************
 ** WEBPACK FOOTER
 ** /~/core-js/modules/_html.js
 ** module id = 49
 ** module chunks = 9
 **/